import {
  customScrollMinimal,
  Markdown as MarkdownBase,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid var(--border-soft);
  cursor: pointer;
  max-height: 150px;

  &:hover {
    background: var(--surface-active);
  }

  ${({ $active }) =>
    $active &&
    `
    background: var(--surface-active);
    `}
`;

export const MarkdownWrapper = styled.span<{ $condensed?: boolean }>`
  ${customScrollMinimal};
  overflow: auto;
  ${({ $condensed }) => $condensed && `max-height: 100px;`};
  ${typographyV2.bodySm};

  ${MarkdownBase.Styled.MarkdownStyles} {
    p {
      margin-bottom: 0;
    }
  }
`;

export const StyledLabel = styled.span`
  word-wrap: break-word;
  overflow-wrap: break-word;
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
